import { axios } from '@/utils/request'
// 公共接口
/**
 * 获取仓库列表
 * @param parameter
 * @returns {*}
 */
export function commonStoreList (parameter) {
  return axios({
    url: '/common/storelist',
    method: 'get',
    params: parameter
  })
}
